// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "#other-user-group-member-register[data-v-2aa381c0]{max-width:600px;margin-left:auto;margin-right:auto}#other-user-group-member-register .cancel-btn[data-v-2aa381c0],#other-user-group-member-register .register-btn[data-v-2aa381c0]{width:120px}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
